<template>
  <div>
    <v-container fluid>
      <!-- <notify-menu></notify-menu> -->
      <v-layout>
        <v-flex>
          <div>
            <v-layout row wrap align-end>
              <v-flex shrink>
                <v-layout row wrap>
                  <v-flex xs6>
                    <div class="form-control" style="position: relative">
                      <div class="labelinputontop">{{ $t('start_date') }}</div>
                      <DatePickerWithoutButton v-model="selectedDate.start" @change="onChangeDate">
                        <input readonly :value="DateFormat(selectedDate.start)" type="text" />
                      </DatePickerWithoutButton>
                    </div>
                  </v-flex>
                  <v-flex xs6 class="pl-2">
                    <div class="form-control" style="position: relative">
                      <div class="labelinputontop">{{ $t('end_date') }}</div>
                      <DatePickerWithoutButton v-model="selectedDate.end" @change="onChangeDate">
                        <input readonly :value="DateFormat(selectedDate.end)" type="text" />
                      </DatePickerWithoutButton>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-flex xs12>
                    <div class="text-xs-left text-sm-right">
                      <!-- <exportxlsx></exportxlsx> -->
                      <span>
                        <v-btn
                          :loading="exportloading"
                          outline
                          color="grey"
                          class="ma-0 mb-0"
                          @click="exportData"
                        >
                          <em class="fas fa-file-export mr-1" /> {{ $t('export') }}
                        </v-btn>
                      </span>
                      <!-- <TicketEditDialog
                        :type="'add'"
                        :loading="loading"
                        @addTicket="onAddTicket"
                      ></TicketEditDialog> -->
                      <v-btn ripple color="primary" outline @click="handleGetAllData">
                        <em class="fa fa-refresh" />
                        <span class="pl-2">{{ $t('refresh') }}</span>
                      </v-btn>
                      <v-btn depressed color="primary" @click="showAdvancedSearch = true">
                        <v-icon>search</v-icon>
                        <span class="pl-2">{{ $t('advanced_search') }}</span>
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
          <div>
            <v-layout row wrap class="mb-0 pl-2">
              <v-flex xs12 sm5>
                <v-btn
                  color="primary"
                  :disabled="selectedTicket && selectedTicket.length == 0"
                  @click="showDialogSelectAgent = true"
                >
                  Transfer
                </v-btn>
              </v-flex>
              <v-flex xs12 sm7 class="pt-0">
                <div class="text-xs-right">
                  <v-pagination
                    v-model="page"
                    :length="pagelength"
                    :total-visible="7"
                    @input="changepage"
                  ></v-pagination>
                </div>
              </v-flex>
            </v-layout>
          </div>
          <v-layout row wrap class="mb-0">
            <v-flex xs12 md3 class="pa-2 mt-0">
              <TicketFilter
                style="background-color: #eee; border-radius: 8px"
                :filter="filter"
                @onSearch="onSearch"
              />
            </v-flex>
            <v-flex xs12 md9 class="pa-2">
              <div>
                <div
                  class="my-0 pa-3"
                  style="background-color: #eee; border-radius: 10px; min-height: 400px"
                >
                  <div v-if="loading">
                    <scale-loader class="mt-5" :loading="true" :color="'grey'"></scale-loader>
                  </div>
                  <div v-else-if="!tickets.length">
                    <div class="text-xs-center pt-5" style="font-size: 25px">
                      <em style="font-size: 50px" class="far fa-folder-open" />
                      <br />
                      {{ $t('no_data') }}
                    </div>
                  </div>
                  <div v-else-if="!$store.state.loadingAgentGroups">
                    <div v-for="(item, k) in tickets" :key="item.id" class="mb-2">
                      <TicketItem
                        :ticket.sync="tickets[k]"
                        :selected="selectedTicket"
                        @ontransfer="onSearch"
                        @onSelect="handleSelectTicket(item)"
                      ></TicketItem>
                    </div>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-dialog v-model="showAdvancedSearch" persistent width="600px">
        <AdvancedSearch @close="handleCloseSearch" @onSearch="onSearch"></AdvancedSearch>
      </v-dialog>
    </v-container>
    <v-dialog v-model="showDialogSelectAgent" persistent width="500px">
      <DialogSelectAgent
        v-if="showDialogSelectAgent"
        @close="showDialogSelectAgent = false"
        @selectedAgent="handleTransferTicket"
      />
    </v-dialog>
  </div>
</template>

<script>
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import moment from 'moment'
import TicketItem from './TicketItem.vue'
import api from '@/api'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import AdvancedSearch from './AdvancedSearch.vue'
import XLSX from 'xlsx'
import ticket3TicketManagementApi from '@/api/ticket3/ticket-management'
import { mapGetters } from 'vuex'
import { handleApiError } from '@/api/util'
import DialogSelectAgent from './DialogSelectAgent.vue'
import TicketFilter from './TicketFilter.vue'
export default {
  components: {
    DatePickerWithoutButton,
    TicketFilter,
    TicketItem,
    ScaleLoader,
    AdvancedSearch,
    DialogSelectAgent
  },
  data() {
    return {
      exportloading: false,
      limit: 10,
      page: 1,
      pagetmp: 1,
      pagetotal: 0,
      offset: 0,
      loading: false,
      showAdd: false,

      optionsTags: [],
      // id | starttime | endtime | updatetime | adminupdatetime | first_assign_ticket_timestamp | assign_ticket_timestampid | starttime | endtime | updatetime | adminupdatetime | first_assign_ticket_timestamp | assign_ticket_timestamp

      input: {
        search: ''
      },
      filter: {
        search: '',
        sortBy: 'assign_ticket_timestamp',
        channel: 'all',
        priority: '',
        status: ['pending', 'answered'],
        pageid: '',
        tags: [],
        id: '',
        subject: '',
        assignGroupId: '',
        assignSubGroupId: '',
        assignAdminId: '',
        contact_phone: '',
        contact_email: '',
        wrap_up: []
      },
      tickets: [],
      selectedDate: {
        start: moment().subtract(3, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      showAdvancedSearch: false,
      countTicketData: null,
      countTicketLoading: false,
      showDialogSelectAgent: false,
      selectedTicket: []
    }
  },
  computed: {
    pagelength() {
      if (this.pagetotal) {
        return Math.ceil(this.pagetotal / this.limit)
      } else {
        return 1
      }
    },
    ...mapGetters(['selectedBot'])
  },
  async mounted() {
    // this.handleGetTicket3(this.limit, this.offset)
    await this.$store.dispatch('loadAgents')
    await this.$store.dispatch('loadAgentGroups')
    await this.$store.dispatch('loadAgentSubGroups')
    this.handleGetAllData()
  },
  methods: {
    handleSelectTicket(ticket) {
      if (this.selectedTicket.includes(ticket)) {
        this.selectedTicket = this.selectedTicket.filter((el) => el.id !== ticket.id)
      } else {
        this.selectedTicket.push(ticket)
      }
    },
    async handleTransferTicket(value) {
      const vm = this
      try {
        const result = await vm.$swal.fire({
          type: 'warning',
          html: `<strong>${vm.$t('confirm_transfer_ticket')} <br/>${value.agent} ${vm.$t(
            'confirm_transfer_ticket_1'
          )}</strong>`,
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })

        if (result.value) {
          vm.$store.dispatch('loading')
          const response = await vm.transferTickets(value)
          vm.$store.dispatch('loading')

          if (response && response.status === 204) {
            vm.selectedTicket = []
            vm.onSearch()

            vm.$swal.fire({
              type: 'success',
              html: `<strong>${vm.$t('transfer_ticket_success')}  <br/>  ${value.agent} ${vm.$t(
                'transfer_ticket_success_1'
              )} </strong>`,
              confirmButtonText: vm.$t('ok')
            })
          }
        } else {
          vm.showDialogSelectAgent = true
        }
      } catch (error) {
        console.error(error)
      }
    },
    async transferTickets(value) {
      console.log(value)
      let selectedTicketId = []
      try {
        const selectedTicket = this.selectedTicket
        if (selectedTicket && selectedTicket.length > 0) {
          selectedTicketId = selectedTicket.map((el) => {
            return { id: el.id, pageid: el.pageid }
          })
        } else {
          return null
        }
        const ticketListByPageId = selectedTicketId.reduce((prev, curr) => {
          if (prev[curr.pageid]) {
            prev[curr.pageid].push(curr.id)
          } else {
            prev[curr.pageid] = [curr.id]
          }
          return prev
        }, [])

        const keys = Object.keys(ticketListByPageId)
        const ticketUpdatePromises = []

        for (const key of keys) {
          if (key && Object.hasOwnProperty.call(ticketListByPageId, key)) {
            ticketUpdatePromises.push(this.saveBatchTickets(key, ticketListByPageId[key], value))
          }
        }

        const ticketUpdateResults = await Promise.all(ticketUpdatePromises)
        const response = ticketUpdateResults.reduce((prev, curr) => {
          if (curr && curr.status === 204) {
            prev.status = 204
          }
          return prev
        }, {})

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    async saveBatchTickets(page_id, ids, transferInfo) {
      try {
        const data = {
          page_id: page_id,
          transfer_to_group_id: transferInfo.group ? transferInfo.group : null, // OPTIONAL
          transfer_to_sub_group_id: transferInfo.subgroup ? transferInfo.subgroup : null, // OPTIONAL
          transfer_to_admin_id: transferInfo.agent,
          ticket_id_list: ids
        }

        const response = await ticket3TicketManagementApi.putTransferMultiTicket({ data: data })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    formatFilter() {
      var data = {}

      if (this.filter.status) {
        data.status = this.filter.status ? this.filter.status.join(',').toLowerCase() : ''
      }
      if (this.filter.priority) {
        data.priority = this.filter.priority
      }
      if (this.filter.search) {
        data.search = this.filter.search
      }
      if (this.filter.sortBy) {
        data.sort_by = this.filter.sortBy
      }
      if (this.filter.tags) {
        data.tags = this.filter.tags.join(',').toLowerCase()
      }
      if (this.selectedDate.start) {
        data.start_date = this.selectedDate.start
      }
      if (this.selectedDate.end) {
        data.end_date = this.selectedDate.end
      }

      if (this.filter.assignAdminId) {
        data.assignAdminId = this.filter.assignAdminId
      }
      if (this.filter.assignGroupId) {
        data.assignGroupId = this.filter.assignGroupId
      }
      if (this.filter.assignSubGroupId) {
        data.assignSubGroupId = this.filter.assignSubGroupId
      }
      if (this.filter.channel) {
        data.channel = this.filter.channel
      }
      if (this.filter.contact_email) {
        data.contact_email = this.filter.contact_email
      }
      if (this.filter.contact_phone) {
        data.contact_phone = this.filter.contact_phone
      }
      if (this.filter.id) {
        data.id = this.filter.id
      }
      if (this.filter.pageid) {
        data.pageid = this.filter.pageid
      }
      if (this.filter.subject) {
        data.subject = this.filter.subject
      }
      data.sort_type = 'desc'
      console.log('filter', this.filter)

      if (this.filter.wrap_up && this.filter.wrap_up.length > 0) {
        data.wrap_up = this.filter.wrap_up
          .map((el) => el.value)
          .join(',')
          .toLowerCase()
      }
      console.log(data.wrap_up)

      return data
    },
    handleFormatTicket(data) {
      const { id, status, tags, ...rest } = data.user || {}
      const { id: group_id, ...groupRest } = data.group || {}
      const { id: subgroup_id, ...subgroupRest } = data.sub_group || {}
      return {
        ...data.ticket,
        assignadminid:
          data.ticket && data.ticket.assignadminid ? data.ticket.assignadminid.toString() : null,
        assignedTo:
          data.ticket && data.ticket.assignedTo ? data.ticket.assignedTo.toString() : null,
        assigngroupid:
          data.ticket && data.ticket.assigngroupid ? data.ticket.assigngroupid.toString() : null,
        assignsubgroupid:
          data.ticket && data.ticket.assignsubgroupid
            ? data.ticket.assignsubgroupid.toString()
            : null,
        group_id,
        subgroup_id,
        ...groupRest,
        ...subgroupRest,
        ...rest,
        user_id: id,
        user_status: status,
        user_tags: tags
      }
    },
    async exportData() {
      const vm = this
      const filename = 'ticketlist'

      let json = []

      const filter = this.formatFilter()
      vm.exportloading = true
      let data = {
        page_id: this.selectedBot.pageid,
        ...filter
      }
      try {
        const response = await ticket3TicketManagementApi.getTicketManagement({ params: data })
        let tickets = []
        if (response.status == 200 && response.data && response.data.data) {
          tickets =
            response.data.data &&
            response.data.data.map((el) => {
              return this.handleFormatTicket(el)
            })
        }
        json = tickets.map((el) => {
          var objData
          objData = {
            ID: el.id ? el.id : '-',
            Priority: el.priority ? el.priority : '-'
          }

          if ([...this.$store.state.oceanlifePage].includes(this.selectedBot.pageid)) {
            let extraExport = {
              คะแนนความพึงพอใจ: el.satisfaction_score ? el.satisfaction_score : '-',
              คะแนนในการแนะนำบริการ: el.recommendation_score ? el.recommendation_score : '-'
            }
            Object.assign(objData, extraExport)
          }

          let adminTakeTime =
            el.starttime && el.adminfirstresponsetime
              ? this.durationTime(el.starttime, el.adminfirstresponsetime)
              : '-'

          const channel = this.$store.state.nestlePages.some(
            (page) => page.pageid == this.selectedBot.pageid
          )
            ? this.selectedBot.pagename
            : el.app

          Object.assign(objData, {
            Name: el.first_name ? `${el.first_name}${el.last_name ? ` ${el.last_name}` : ''}` : '-',
            'Latest Email': el.email ? el.email : '-',
            Channel: channel ? channel : '-',
            Subject: el.subject ? el.subject : '-',
            Details: el.details ? el.details : '-',
            Status: el.status ? el.status : '-',
            'Assign To': el.assignadminid ? el.assignadminid : '-',
            // Group: this.groups[el.assigngroupid] ? this.groups[el.assigngroupid].groupname : '-',
            // Subgroup: this.subgroups[el.assignsubgroupid]
            //   ? this.subgroups[el.assignsubgroupid].subgroupname
            //   : '-',
            'Start time (Date)': el.starttime ? moment(el.starttime).format('DD/MM/YYYY') : '-',
            'Start time (Time)': el.starttime ? moment(el.starttime).format('HH:mm') : '-',
            'Admin First Response (Date)': el.adminfirstresponsetime
              ? moment(el.adminfirstresponsetime).format('DD/MM/YYYY')
              : '-',
            'Admin First Response (Time)': el.adminfirstresponsetime
              ? moment(el.adminfirstresponsetime).format('HH:mm')
              : '-',
            'Admin take time': adminTakeTime,
            'End Time': el.endtime ? moment(el.endtime).format('DD/MM/YYYY HH:mm') : '-',
            'Time Closed':
              el.starttime && el.endtime ? this.durationTime(el.starttime, el.endtime) : '-',
            'Due Date': el.duedate ? el.duedate : '-',
            Tags: el.tags ? el.tags : '-',
            wrap_up: el.wrap_up ? el.wrap_up.join(', ') : '-',
            wrap_up_route: el.wrap_up_route
              ? el.wrap_up_route.map((wrapUp) => Object.values(wrapUp).join(' > ')).join(', ')
              : '-'
          })

          return objData
        })

        var dataWS = XLSX.utils.json_to_sheet(json)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, dataWS)
        XLSX.writeFile(wb, filename + '.xlsx')
      } catch (error) {
        console.error(error)
      } finally {
        vm.exportloading = false
      }
    },
    durationTime(start, end) {
      var startTime = start
      var endTime = end
      var minutes = moment
        .duration(moment(endTime, 'YYYY/MM/DD HH:mm').diff(moment(startTime, 'YYYY/MM/DD HH:mm')))
        .asMinutes()
        .toFixed(2)
      return minutes
    },
    onChangeDate() {
      this.handleGetAllData()
    },
    changepage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.page * vm.limit - vm.limit
        if (vm.page != 1) {
          vm.offset + 1
        }
        this.handleGetAllData()
      }
    },
    onAddTicket() {
      this.onSearch()
    },
    showAddDialog() {
      this.showAdd = true
    },
    addTag(newTag) {
      this.optionsTags.push(newTag)
      this.filter.tags.push(newTag)
    },
    onSearch(payload) {
      if (payload) {
        this.filter.id = payload.ticket_id
        this.filter.subject = payload.ticket_name
        this.filter.group_id = payload.group ? payload.group.id : ''
        this.filter.subgroup_id = payload.subgroup ? payload.subgroup.id : ''
        this.filter.assign_admin_id = payload.agent_name ? payload.agent_name.adminid : ''
        this.filter.contact_phone = payload.phone_number
        this.filter.contact_email = payload.email
        this.filter.tags = payload.tags
      }
      this.handleGetAllData()
      this.handleCloseSearch()
    },
    handleFormatDataBeforeGetTicket(data) {
      const tmpData = { ...data }
      Object.entries(this.filter).forEach(([key, value]) => {
        if (value && value.length) {
          if (Array.isArray(value)) {
            if (typeof value[0] != 'string') {
              Object.assign(tmpData, {
                [key]: value
                  .map((el) => el.value)
                  .join(',')
                  .toLowerCase()
              })
            } else {
              Object.assign(tmpData, { [key]: value.join(',').toLowerCase() })
            }
          } else {
            if (key == 'channel' && value == 'all') {
              //
            } else {
              if (key == 'assign_admin_id') {
                Object.assign(tmpData, { [key]: value })
              } else {
                Object.assign(tmpData, { [key]: value.toLowerCase() })
              }
            }
          }
        }
      })

      return tmpData
    },
    async handleGetAllData() {
      const vm = this

      let data = {
        page_id: vm.selectedBot.pageid,
        start_date: vm.selectedDate.start,
        end_date: vm.selectedDate.end,
        limit: vm.limit,
        offset: vm.offset,
        role: vm.$store.state.privilege.role
      }

      data = { ...data, ...vm.handleFormatDataBeforeGetTicket(data) }

      const allGet = [vm.handleGetTicket3(data)]
      vm.loading = true
      await Promise.all(allGet)
      vm.loading = false
      return true
    },
    async handleGetTicket3(data) {
      this.loading = true
      try {
        const response = await ticket3TicketManagementApi.getTicketManagement({
          params: {
            ...data
          }
        })

        this.loading = false
        if (response.status == 200) {
          const result = response.data.data.map((el) => {
            return this.handleFormatTicket(el)
          })
          this.tickets = result
          this.pagetotal = parseInt(response.data.total)
        }
      } catch (error) {
        handleApiError(error)
      }
    },
    async handleGetCountTicket(data) {
      const vm = this
      try {
        if (['studio7'].includes(vm.selectedBot.theme)) {
          if (vm.filter.pageid) {
            const tempSelectPage = vm.$store.state.com7pages.find((el) => {
              return el.pageid == vm.filter.pageid
            })

            if (tempSelectPage) {
              Object.assign(data, { pageSelect: tempSelectPage.name })
            } else {
              Object.assign(data, { pageSelect: 'All' })
            }
          } else {
            Object.assign(data, { pageSelect: 'All' })
          }
        }

        const response = await api.ticket2GetCountTicket(data)

        if (response) {
          vm.countTicketData = response.data
        }
      } catch (error) {
        vm.countTicketLoading = false
        console.error(error)
        return
      }
    },
    handleCloseSearch() {
      this.showAdvancedSearch = false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/TicketList.vue